import { Field, Input, Label } from "@headlessui/react";
import { ComponentProps, useContext } from "react";
import cx from "classnames";
import { FormLabelsContext } from "./FormLabelsContext";

export const TextInput = ({
  label,
  inputProps = {},
  className,
  invalid,
  subtext,
}: {
  label: string;
  isInvalid?: boolean;
  inputProps?: Omit<ComponentProps<"input">, "ref">;
  className?: string;
  size?: "default" | "small";
  invalid?: boolean;
  subtext?: string,
}) => {
  const otherLabels = useContext(FormLabelsContext);

  return (
    <Field className={cx("text-body-regular", className)}>
      <div className="flex gap-2 items-center ml-3">
        <Label>{label}</Label>
        {inputProps.required && (
          <span className="italic text-body-small text-brand-cream text-opacity-30">
            {otherLabels?.required}
          </span>
        )}
      </div>
      <div className="flex items-center mb-2 ml-3">
      {subtext && (
          <span className="text-body-small text-brand-cream text-opacity-60">
            {subtext}
          </span>
        )}
      </div>
      <div className="flex items-center">
        <div className="relative w-full">
          <Input
            {...inputProps}
            className={cx(
              "w-full h-14 border px-3 border-brand-cream/30 text-brand-cream rounded-lg bg-transparent outline-none focus:border-brand-cream focus:bg-brand-black transition-colors",
              invalid &&
                "!border-brand-red bg-gradient-to-r from-brand-red/15 to-brand-red/15",
              inputProps.className
            )}
          />
        </div>
      </div>
    </Field>
  );
};
